export default __webpack_public_path__ + "static/media/logo.b47ed324.png";